"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalGroupState = exports.useModalState = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useModalState = function useModalState() {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var handleOpen = (0, _react.useCallback)(function () {
    setOpen(true);
  }, []);
  var handleClose = (0, _react.useCallback)(function () {
    setOpen(false);
  }, []);
  var handleToggle = (0, _react.useCallback)(function () {
    setOpen(function (open) {
      return !open;
    });
  }, []);
  return (0, _react.useMemo)(function () {
    return {
      isOpen: isOpen,
      handleOpen: handleOpen,
      handleClose: handleClose,
      handleToggle: handleToggle
    };
  }, [isOpen, handleOpen, handleClose, handleToggle]);
};

exports.useModalState = useModalState;

var useModalGroupState = function useModalGroupState() {
  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      curModal = _useState4[0],
      setCurModal = _useState4[1];

  var handleOpen = (0, _react.useCallback)(function (name) {
    setCurModal(name);
  }, []);
  var handleClose = (0, _react.useCallback)(function () {
    setCurModal(null);
  }, []);
  var isAnyOpen = curModal !== null;
  return (0, _react.useMemo)(function () {
    return {
      opened: curModal,
      isAnyOpen: isAnyOpen,
      handleOpen: handleOpen,
      handleClose: handleClose
    };
  }, [curModal, isAnyOpen, handleClose, handleOpen]);
};

exports.useModalGroupState = useModalGroupState;